var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84303 0.255871C5.25404 0.307247 5.54559 0.68209 5.49421 1.09311L5.22459 3.25008H9.71291L10.0058 0.907053C10.0572 0.496038 10.432 0.204494 10.843 0.255871C11.254 0.307247 11.5456 0.68209 11.4942 1.09311L11.2246 3.25008H13C13.4142 3.25008 13.75 3.58587 13.75 4.00008C13.75 4.41429 13.4142 4.75008 13 4.75008H11.0371L10.4746 9.25008H13C13.4142 9.25008 13.75 9.58587 13.75 10.0001C13.75 10.4143 13.4142 10.7501 13 10.7501H10.2871L9.99421 13.0931C9.94283 13.5041 9.56799 13.7957 9.15697 13.7443C8.74596 13.6929 8.45441 13.3181 8.50579 12.9071L8.77541 10.7501H4.28709L3.99421 13.0931C3.94283 13.5041 3.56799 13.7957 3.15697 13.7443C2.74596 13.6929 2.45441 13.3181 2.50579 12.9071L2.77541 10.7501H1C0.585786 10.7501 0.25 10.4143 0.25 10.0001C0.25 9.58587 0.585786 9.25008 1 9.25008H2.96291L3.52541 4.75008H1C0.585786 4.75008 0.25 4.41429 0.25 4.00008C0.25 3.58587 0.585786 3.25008 1 3.25008H3.71291L4.00579 0.907053C4.05717 0.496038 4.43201 0.204494 4.84303 0.255871ZM5.03709 4.75008L4.47459 9.25008H8.96291L9.52541 4.75008H5.03709Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashTag);
export default __webpack_public_path__ + "static/media/hash-tag.d3e0b33c7e83aae527702d18cd683f0a.svg";
export { ForwardRef as ReactComponent };